import React from 'react';

import logo from '../res/img/orca.png';

export default class Home extends React.Component {

    render = () => (
        <div className="App">
            <header className="App-header">
                <img src={logo} className="orca-logo" alt="logo" />
            </header>
        </div>
    )

}